let AddressBuilder = (type, address1, address2, city, state, postalCode, country) => {
    var address = {
        type: type,
        line: [address1, address2],
        city: city,
        state: state,
        postalCode: postalCode,
        country: country,            
    }; 
    return address;
}
export default AddressBuilder;
//# sourceMappingURL=address.js.map